export default __webpack_public_path__ + "static/media/banner-subtitle-img.079a6229.png";